import { useContext } from "react";
import { context } from "../contexts";
import { Navigate } from "react-router-dom";
export default function Private({ children }) {
  // o usuario so consegue acessar as rotas de dentro do site se estiver logado
  const { signed } = useContext(context);

  

  if (signed === false) {
    return <Navigate to="/" />;
  } else {
    return children;
  }
}
